<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="8"
            offset-md="2"
            class="pa-1 mt-10">
                 <v-card>
                     <v-card-title>
                          <span style="width: 200px; margin-right: 4px;">
                          <v-select
                           filled
                            outlined
                            label="Select Type"
                            @change="clear(),getCustomers()"
                            dense
                          v-model="paymentType"
                          :items="['Cash']"
                          />
                          </span>
                            <v-autocomplete
                            dense
                            filled
                            outlined
                            success
                            v-model="customer"
                            :items="customers"
                            item-text="firstname"
                            item-value="id" 
                            @change="clear(), data_type='sales', getSale()"
                            label="Select Customer"
                              return-object
                            ></v-autocomplete>
                     </v-card-title>
                     <v-card-text>
                        <v-row no-gutter>
                          <v-spacer/>
                          <v-card class="elevation-0" width="220">
                                  <v-menu
                                  ref="menu"
                                  v-model="datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  :min-width="paymentType =='credit'?'600px':'290px'"
                              >
                                  <template v-slot:activator="{ on }">
                                  <v-text-field
                                      :value="paymentType =='Credit'?selected_date +' - '+selected_date2:selected_date"
                                      label="select date range"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      dense
                                      single-line
                                      class="mr-2 sm-width"
                                      hide-details
                                      v-on="on"
                                  ></v-text-field>
                                  </template>
                                  <v-date-picker class="ma-1" v-model="selected_date" no-title scrollable @input="CurrentItems=[], paymentType =='Cash'?getCustomers():getSale(), paymentType =='Cash'?datemenu = false:CurrentItems=[]" />
                                   <v-date-picker v-if="paymentType =='Credit'" class="ma-1" v-model="selected_date2" no-title scrollable @input="datemenu = false, CurrentItems=[], getSale()" />
                              </v-menu>
                            </v-card>

                        </v-row>
                             <div class="text-left mb-5" v-if="customer.id != null">
                                   <v-btn small color="info" class="ma-1" v-if="data_type=='modified'" @click="data_type='sales', getSale()">View Current sales</v-btn>
                                     <v-btn small color="error"  v-if="data_type=='sales'" @click="data_type='modified', getModified()">View Modified sales</v-btn>
                             </div>
                                   <v-alert class="warning" dark dense>
                                     Viewing: 
                                                <template v-if="data_type=='sales'">
                                                    Current Sales
                                                </template>
                                                <template v-else>
                                                         Modified Sales

                                                </template>
                                   </v-alert>
                            <v-data-table
                                class="va-table"
                                :headers="headers"
                                :items-per-page="10"
                                :items="ITEMS"
                                disable-sort
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                              <v-icon @click="modformindex = index,sales=item, state='update', openform()" left color="warning" small>mdi-pencil</v-icon>
                                            {{ item.name }}
                                            </td>
                                           <td>
                                                {{ $money(item.price) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.kilos) }}
                                            </td> <td class="text-right">
                                                {{ $money(parseFloat(item.kilos) * parseFloat(item.price)) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.service_charge) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.trucking_fee) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                                            </td>
                                    </tr>
                                     <tr class="title">
                                            <td>
                                                Viewing: 
                                                <template v-if="data_type=='sales'">
                                                    Current Sales
                                                </template>
                                                <template v-else>
                                                         Modified Sales

                                                </template>
                                            </td>
                                           <td>
                                               
                                            </td>
                                            <td class="text-right">
                                                <!-- {{ $money(KILOS) }} -->
                                            </td>
                                             <td class="text-right">
                                             
                                            </td>
                                            <td class="text-right">
                                                {{ $money(SERVICE_CHARGE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TRUCKING_FEE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TOTAL_AMOUNT) }}
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                          <div v-if='data_type != "sales"'>
                              <v-alert class="info" v-if='ITEMS.length == 0'>
                                    No data found! <v-btn small class="ml-5" @click="addModifiedData()">Save data to modify!</v-btn>
                              </v-alert>
                          </div>
                     </v-card-text>
                     <v-card-actions v-if="paymentType == 'Credit'">
                        <p  class="pa-2">     
                        <v-icon left color="secondary">mdi-cart</v-icon> <span class="va-underline">SALES </span><br /> 
                        <span>{{$money(account.collectible)}}</span>
                        </p>
                        <v-spacer />
                        <p  class="pa-2">
                        <v-icon left color="secondary">mdi-bank-transfer-in</v-icon> <span class="va-underline">PAYMENTS</span> <br /> 
                        <span>{{$money(account.payout)}}</span>
                        </p>
                        <v-spacer />
                        <p  class="pa-2">
                        <v-icon left color="secondary">mdi-account-cash</v-icon> <span class="va-underline">COLLECTIBLES</span><br /> 
                        <span>{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</span>
                        </p>
                              
                          
                     </v-card-actions>
                 </v-card>
                
                <v-footer class="pa-0 mt-10">
                
                  <v-spacer/>
                  <v-btn @click="cashierprint=true" text class="mr-2"><v-icon>mdi-printer</v-icon></v-btn>
                 <v-btn small color="secondary" @click="setPayment()">PAY</v-btn>
                </v-footer>
                <p class="caption pa-4" style="color: green;" v-if="IS_PAID">
                   <v-icon small left color="success">mdi-check-circle</v-icon> PAYMENT COMPLETED
                </p>
            </v-col>
        </v-row>
        <va-sales-form :show="form" :sales="sales" :state="state" :customers="all_customers" :fishcars="FISHCARS"  @DialogEvent="formEvent" />
        <va-modified-sales :show="modform" :sales="sales" :state="state" :customers="all_customers" :fishcars="FISHCARS"  @DialogEvent="modformEvent" />
        <va-pay-form :show="payform" :payment="payment" :type="paymentType" @DialogEvent="payEvent" />
        <print-cashier :show="cashierprint" :items="CurrentItems" :customer="customer" @DialogEvent="prEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        form: false,
        modform: false,
        modformindex: null,
        paymentType:"Cash",
        cashierprint: false,
        payform: false,
        loading: false,
        customer:{},
        payments:[],
        payment:{},
        account:{},
        customers:[],
        CurrentItems:[],
        modifiedData: [],
        data_type: 'sales',
        datemenu: false,
        sales:{},
        settings:[],
        state: 'update',
        selected_date:'',
        selected_date2: '',
        Fishcars:[],
        all_customers:[],
        headers:[
            {text: 'Fish', value: 'name', sortable: false},
            {text: 'Price/Kg', value: 'price', sortable: false},
            {text: 'Weight(Kg)', value: 'kilos', sortable: false, align: 'right'},
             {text: 'Amount', sortable: false, align: 'right'},
             {text: 'SC', value: 'service_charge', sortable: false, align: 'right'},
            {text: 'Trucking', value: 'trucking_fee', sortable: false, align: 'right'},
            {text: 'Total',sortable: false, align: 'right'}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.selected_date2 = this.$moment().format('YYYY-MM-DD')
            this.loadSetting()
            this.getCustomers()
            this.getAllCustomers()
            this.GET_TRANSACTIONS({param1: this.selected_date})
            this.getFishcars()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    ITEMS() {
        if(this.data_type == 'sales') {
            return this.CurrentItems
        } else {
            return this.modifiedData
        }
    },
     AMOUNT() {
          var total = 0
            for(var i =0;i<this.ITEMS.length;i++) {
              total += this.$IsNum(this.ITEMS[i].price) * this.$IsNum(this.ITEMS[i].kilos)
          }
          return total
      },
      KILOS() {
          var total = 0
            for(var i =0;i<this.ITEMS.length;i++) {
              total += this.$IsNum(this.ITEMS[i].kilos)
          }
          return total
      },
      SERVICE_CHARGE() {
          var total = 0
            for(var i =0;i<this.ITEMS.length;i++) {
              total += this.$IsNum(this.ITEMS[i].service_charge)
          }
          return total
      },
      TRUCKING_FEE() {
          var total = 0
            for(var i =0;i<this.ITEMS.length;i++) {
              total += this.$IsNum(this.ITEMS[i].trucking_fee)
          }
          return total
      },
      TOTAL_AMOUNT(){
          return this.AMOUNT + this.SERVICE_CHARGE + this.TRUCKING_FEE
      },
      FISHCARS(){
       return this.Fishcars
      },
      PAYBTN(){
        if(this.ITEMS.length > 0) {
            return true
        } 
        return false
      },
      ITEM_IDS(){
         var ids = []
            for(var i =0;i<this.CurrentItems.length;i++) {
              ids.push(this.CurrentItems[i].id)
          }
          return ids
      },
      IS_PAID(){
         for(var i =0;i<this.payments.length;i++) {
              if(this.payments[i].type == 4) {
                  return true
              }
          }
          return false
     },
      SALESIDS() {
          var ids = []
            for(var i =0;i<this.CurrentItems.length;i++) {
              ids.push(this.CurrentItems[i].id)
          }
          return ids
      },
      TOTAL_CURRENT_COLLECTIBLE() {
        return this.$IsNum(this.account.collectible) - this.$IsNum(this.account.payout)
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),

     openform(){
       if(this.data_type == 'sales') {
         this.form = true
       } else {
         this.modform = true
       }
     }, 
     modformEvent(data){
        this.modform = false
        if(data.action == 'update') {
            // this.modifiedData.splice[this.modformindex, 1, data.sales]
             console.log(this.modifiedData)
             this.SaveModifiedData("modify/update")
        }
     },
     getModified() {
       this.modifiedData = []
        this.$http.post("modify/query", {customer_id: this.customer.id, sales_date: this.selected_date}).then(response => {
          response.data.data != null?this.modifiedData = response.data.data.data:this.modifiedData = []
          console.log(response.data.data )
            }).catch(e => {
            console.log(e.data)
          }) 
     },
    addModifiedData() {
        this.$http.post("customer/get_order", {id: this.customer.id, status: this.selected_date}).then(response => {
          response.data.data != null?this.modifiedData = response.data.data:this.modifiedData = []
          this.SaveModifiedData("modify/add")
            }).catch(e => {
            console.log(e.data)
          }) 
     },
     SaveModifiedData(action) {
        var param = {customer_id: this.customer.id, sales_date: this.selected_date, data: this.modifiedData}
        console.log( this.modifiedData)
        this.$http.post(action, param).then(response => {
              response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
            }).catch(e => {
            console.log(e.data)
          }) 
     },
      setPayment() {
        this.payment.amount = this.TOTAL_AMOUNT
        this.payment.service_charge = this.SERVICE_CHARGE
         this.payment.trucking_fee = this.TRUCKING_FEE
         this.payment.customer = this.customer.id 
        this.payment.items = this.ITEM_IDS
        this.payform = true
      },
      prEvent(){
        this.cashierprint =false
      },
      payEvent(data){
        this.payment={}
          this.payform = false
          if(data == 'completed') {
            if(this.paymentType == 'Cash') {
              this.UpdateIds()
              this.clear()
            } else {
              this.getAccountSummary()
            }
            
          }
      },
      formEvent(data){
        this.form = false
        if(data.action == 'update') {
            this.sales = data.sales
            this.Save()
        }
      },
      getFishcars: function() {
        this.$http.post("supplier/list", {}).then(response => {
              response.data.data != null?this.Fishcars = response.data.data:this.Fishcars=[]
          }).catch(e => {
           console.log(e.data)
         })
     },
       Save(){
            this.$http.post("sale/update", this.sales).then(response => {
            if(response.data.status == true) {
                this.VA_ALERT('success', response.data.message)
            } else {
                this.VA_ALERT('error', response.data.message)
            }
            // this.getTransactions()
            }).catch(e => {
            console.log(e)
            })
        },
        clear() {
         // this.customer = {}
          this.CurrentItems = []
            this.modifiedData = []
          this.account = {}
          this.payments = []
        },
        UpdateIds(){
         this.$http.post("sale/update_status_multiple_id", {ids:this.SALESIDS, to_do:"status", str_val:"paid"}).then(response => {
            if(response.data.status) {
              this.getCustomers()
            }
            }).catch(e => {
            console.log(e.data)
          }) 
      },
      getSale(){
          if(this.paymentType == 'Credit') {
               this.getCreditSales()
            } else {
              this.getCashSales()
            }
      },
      getCashSales() {
        console.log("selected_date: ", this.selected_date)
        // this.GET_TODAYS_FISHCARS({param1: this.selected_date})
        this.$http.post("customer/get_order", {id: this.customer.id, status: this.selected_date}).then(response => {
          response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
            }).catch(e => {
            console.log(e.data)
          }) 
      },
      getCreditSales() {
        this.$http.post("customer/get_credit_sales", {customer: this.customer.id, date: this.selected_date, date2: this.selected_date2}).then(response => {
          response.data.data != null?this.CurrentItems = response.data.data:this.CurrentItems = []
          this.getAccountSummary()
            }).catch(e => {
            console.log(e.data)
          }) 
      },
   getAccountSummary(){
        this.$http.post("transaction/query_total", {account: this.customer.id, account_type: 3}).then(response => {
              response.data.data != null?this.account = response.data.data:this.account={}
              console.log(this.account)
         }).catch(e => {
           console.log(e.data)
         })
     },
     
      loadSetting() {
          this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSettingVal(name) {
          for(var i =0;i<this.settings.length;i++) {
              if(this.settings[i].name == name) {
                  return this.settings[i].value
              }
          }
          return false
      },
      getCustomers: function() { 
            var method = "by_date"
            if(this.paymentType == 'Credit') {
               method = "all_parent"
            }
            console.log({method: method, param1: this.selected_date})
             this.$http.post("customer/list", JSON.stringify({method: method, param1: this.selected_date})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers = []
          }).catch(e => {
           console.log(e.data)
         })
     },
      getAllCustomers: function() { 
          this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.all_customers = response.data.data:this.all_customers = []
          }).catch(e => {
           console.log(e.data)
         })
     }
    }
  }
</script>